import { render, staticRenderFns } from "./WhoWillTake.vue?vue&type=template&id=507c8640&scoped=true"
import script from "./WhoWillTake.vue?vue&type=script&lang=js"
export * from "./WhoWillTake.vue?vue&type=script&lang=js"
import style0 from "./WhoWillTake.vue?vue&type=style&index=0&id=507c8640&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507c8640",
  null
  
)

export default component.exports